/*eslint-disable*/ export const messages = JSON.parse(
    '{"ads.title.mlt":"More like this","ads.title.personal":"Personalized recommendations","ads.title.popular":"Popular ads"}',
);
